export const sortArrayOfObjectsByName = (array) => {

	function compareNames(a, b) {
		const lastNameA = a.last_name.toLowerCase()
		const lastNameB = b.last_name.toLowerCase()

		if (lastNameA < lastNameB) return -1
		if (lastNameA > lastNameB) return 1

		const firstNameA = a.first_name.toLowerCase()
		const firstNameB = b.first_name.toLowerCase()

		if (firstNameA < firstNameB) return -1
		if (firstNameA > firstNameB) return 1

		if (a.middle_name && b.middle_name) {
			const middleNameA = a.middle_name.toLowerCase()
			const middleNameB = b.middle_name.toLowerCase()

			if (middleNameA < middleNameB) return -1
			if (middleNameA > middleNameB) return 1
		}

		return 0
	}

	const sortedArray = array.slice() // copy array
	sortedArray.sort(compareNames)

	return sortedArray
}